
import makeResponsive from "../style-functions/makeResponsive";
import findDirection from "../style-functions/findDirection";
import arrayKeyMapToObject from "../style-functions/arrayKeyMapToObject";
import findRoundedDirection from "../style-functions/findRoundedDirection";
import findBorder from "../style-functions/findBorder";

const computeDivStyle = (props, context) => {
  const {
    pos,
    top,
    bottom,
    left,
    right,
    justify,
    align,
    flexDir,
    flexGrow,
    flexWrap,
    order,
    p,
    rounded,
    border,
    borderColor,
    h,
    maxH,
    minH,
    w,
    minW,
    maxW,
    cursor,
    bg,
    bgImg,
    bgSize,
    bgRepeat,
    bgPos,
    textSize,
    textColor,
    textWeight,
    textAlign,
    textTransform,
    fontFamily,
    shadow,
    transition,
    transform,
    transformOrigin,
    zIndex,
    overflow,
    opacity,
    hoverBg,
    hoverTextColor,
    hoverBorderColor,
    hoverShadow,
    isOpen,
    hover,
    offset,
    size,
    targetHover,
    theme,
    focusBg,
    focusBorderColor,
    focusTextColor,
    focusShadow,
    placeholderTextColor,
    ...rest
  } = props;

  const style = [
    { boxSizing: "border-box" },
    findRoundedDirection(rounded, context.rounded),
    findDirection(p, "padding"),
    makeResponsive(pos, "position"),
    makeResponsive(top, "top"),
    makeResponsive(bottom, "bottom"),
    makeResponsive(left, "left"),
    makeResponsive(right, "right"),
    makeResponsive(justify, "justify-content"),
    makeResponsive(align, "align-items"),
    makeResponsive(flexDir, "flex-direction"),
    makeResponsive(flexGrow, "flex"),
    makeResponsive(flexWrap, "flex-wrap"),
    makeResponsive(order, "order"),
    makeResponsive(h, "height"),
    makeResponsive(maxH, "max-height"),
    makeResponsive(minH, "min-height"),
    makeResponsive(w, "width"),
    makeResponsive(minW, "min-width"),
    makeResponsive(maxW, "max-width"),
    makeResponsive(cursor, "cursor"),
    findBorder(border, borderColor, context.colors),
    makeResponsive(bg, "background", context.colors),
    bgImg ? { backgroundImage: `url(${bgImg}` } : undefined,
    makeResponsive(bgSize, "background-size"),
    makeResponsive(bgRepeat, "background-repeat"),
    makeResponsive(bgPos, "background-position"),
    makeResponsive(bgRepeat, "background-repeat"),
    makeResponsive(bgRepeat, "background-repeat"),
    makeResponsive(textColor, "color", context.colors),
    makeResponsive(textWeight, "font-weight"),
    makeResponsive(textAlign, "text-align"),
    makeResponsive(textTransform, "text-transform"),
    makeResponsive(fontFamily, "font-family", context.fontFamily),
    makeResponsive(transform, "transform"),
    makeResponsive(transformOrigin, "transform-origin"),
    makeResponsive(shadow, "box-shadow", context.shadows),
    makeResponsive(transition, "transition", context.transition),
    makeResponsive(textSize, "font-size", context.textSize.size),
    makeResponsive(textSize, "line-height", context.textSize.height),
    makeResponsive(zIndex, "z-index"),
    makeResponsive(overflow, "overflow"),
    makeResponsive(opacity, "opacity"),
    {
      ":hover": {
        ...makeResponsive(hoverBg, "background", context.colors),
        ...makeResponsive(hoverTextColor, "color", context.colors),
        ...makeResponsive(hoverBorderColor, "border-color", context.colors),
        ...makeResponsive(hoverShadow, "box-shadow", context.shadows)
      },
      ":focus": {
        ...makeResponsive(focusBg, "background", context.colors),
        ...makeResponsive(focusTextColor, "color", context.colors),
        ...makeResponsive(focusBorderColor, "border-color", context.colors),
        ...makeResponsive(focusShadow, "box-shadow", context.shadows)
      },
      "::placeholder": {
        ...makeResponsive(placeholderTextColor, "color", context.colors)
      },
      disabled: {
        color: context.colors[placeholderTextColor] || placeholderTextColor,
        cursor: "not-allowed",
        background: context.colors["gray200"]
      }
    }
  ];

  return [rest, arrayKeyMapToObject(style)];
};

export default computeDivStyle;
